import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useAuthentication } from "../../hooks";
import { LoginTokenLink } from "../../components";

import { LoggedOutTemplate } from "./logged-out.template";

const RELOAD_KEY = "reload";

export const LoggedOut = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { logout } = useAuthentication();

	useEffect(() => {
		logout();

		if (searchParams.get(RELOAD_KEY) === "false") {
			return;
		}

		setSearchParams({ [RELOAD_KEY]: "false" });
		window.location.reload();
	}, [logout, searchParams, setSearchParams]);

	return (
		<>
			<LoggedOutTemplate />
			<LoginTokenLink />
		</>
	);
};
